import { Font, StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    width: "90%",
    // height: 50,
    bottom: 10,
    left: 30,
  },
  line: {
    borderBottomColor: "#f09415",
    borderBottomWidth: 3,
    marginVertical: 10,
    width: "111%",
    // borderBottomWidth: 3,
    // marginVertical: 10,
  },
  pageNo: {
    // fontSize: 13,
    display: "flex",
    marginLeft: "20%",
    alignItems: "center",
  },
  bulkPageFooter: {
    flexDirection: "column",
    width: "100%",
    gap: "0.5rem",
    right: 10,
  },
  disclaimerContainer: {
    display: "flex",
    flexDirection: "row",
  },
  warningContainer: {
    display: "flex",
    flexDirection: "row",
    color: "red",
  },
  disclaimerHeading: {
    fontSize: "13",
    fontWeight: "bolder",
    marginRight: "10px",
  },
  warningHeading: {
    fontSize: "13",
    fontWeight: "bolder",
    marginRight: "20px",
  },
});

const Footer = ({ totalPage = 1, currentPage = 1 }) => {
  return (
    <View style={styles.container}>
      <View style={styles.line} />
      <View style={styles.bulkPageFooter}>
        <View style={styles.disclaimerContainer}>
          <Text style={styles.disclaimerHeading}>Disclaimer:</Text>
          <Text>
            This is a an autogenerated report using AI and is to be correlated
            with other clinical findings.This report does not indicate any
            treatment.
          </Text>
        </View>
        <View style={styles.warningContainer}>
          <Text style={styles.warningHeading}>WARNING!!</Text>
          <Text>
            Images presented in this report are only for illustration purpose,
            and not to be used as is for any further diagnosis.
          </Text>
        </View>
        <View style={styles.pageNo}>
          <Text>
            Page No.:{currentPage}/{totalPage}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default Footer;
